import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TablerIconsModule } from 'angular-tabler-icons';
@Component({
  selector: 'app-confirmar-dialog-ui',
  standalone: true,
  templateUrl: './confirmar-dialog.component.html',
  styleUrl: './confirmar-dialog.component.scss',
  imports: [CommonModule, MatButtonModule, TablerIconsModule],
})
export class ConfirmarDialogUiComponent {
  @Input() loading = false;
  @Input() modalTitle = '';
  @Input() modalMessage = '';
  @Input() warn = false;
  @Input() mainButtonName = 'Confirmar';
  @Input() totalTasks = 0;
  @Input() processedTasks = 0;
  @Input() progressPercent = 0;
  @Input() progressLabel = 'Procesando';

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    this.confirm.emit();
  }
}
